export const START_LOADER = '@loader/start-loader';
export const STOP_LOADER = '@loader/stop-loader';

export function startLoader() {
  return (dispatch: any) => {
    dispatch({
      type: START_LOADER
    });
  };
}

export function stopLoader() {
  return (dispatch: any) => {
    dispatch({
      type: STOP_LOADER
    });
  };
}
